import { render, staticRenderFns } from "./DGForm.vue?vue&type=template&id=0e49658f"
import script from "./DGForm.vue?vue&type=script&lang=ts"
export * from "./DGForm.vue?vue&type=script&lang=ts"
import style0 from "./DGForm.vue?vue&type=style&index=0&id=0e49658f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports